import { Loader2 } from 'lucide-react';
import { IS_PRODUCT } from '../../brand';
import { Nugget } from '../../brand/Nugget';

const SIZES = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-8 h-8',
};

const NUGGET_SIZES = { xs: 20, sm: 24, md: 32, lg: 84 };

// Loading indicator. `label` is read by screen readers via the wrapping
// role="status". Keep it short — "Loading", "Saving", "Sending".

const Spinner = ({ size = 'md', label = 'Loading…', className = '' }) => (
  <span
    role="status"
    className={['inline-flex items-center gap-2 text.muted', className].filter(Boolean).join(' ')}
  >
    {IS_PRODUCT ? (
      <Nugget pose="wagging" size={NUGGET_SIZES[size] || NUGGET_SIZES.md} />
    ) : <Loader2
      className={`${SIZES[size] || SIZES.md} animate-spin motion-reduce:animate-none`}
      aria-hidden="true"
    />}
    <span className="sr-only">{label}</span>
  </span>
);

export default Spinner;
